import React, { useRef, useState } from "react";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lightgallery-core.css.map";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import "../css/DetailBooking.css";
import { FaCamera, FaMapMarkerAlt, FaTimes } from "react-icons/fa";

const DetailRoom = () => {
  const totalPhotos = 10;
  const displayedPhotos = 5;
  const extraPhotos = totalPhotos - displayedPhotos;

  const lightGalleryRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);

  const images = Array.from({ length: totalPhotos }, (_, i) => ({
    src: "https://pix8.agoda.net/hotelImages/394319/-1/8740f4b31b678f40cca7876cd813e2b8.jpg?ca=29&ce=0&s=1024x",
    thumb:
      "https://pix8.agoda.net/hotelImages/394319/-1/8740f4b31b678f40cca7876cd813e2b8.jpg?ca=29&ce=0&s=1024x",
    subHtml: `<h4>Photo ${i + 1}</h4>`,
  }));

  const openGallery = (index) => {
    if (
      lightGalleryRef.current &&
      lightGalleryRef.current.instance &&
      typeof lightGalleryRef.current.instance.openGallery === "function"
    ) {
      lightGalleryRef.current.instance.openGallery(index);
    }
  };

  const openMapModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="detail-room-container">
      <header className="detail-room-header">
        <div className="header-left">
          <h1 className="property-name">Satana Homestay</h1>
          <p className="property-address">
            <FaMapMarkerAlt className="map-icon" /> Jalan Urip Sumoharjo, Depok,
            Yogyakarta{" "}
            <span className="see-map" onClick={openMapModal}>
              See Map
            </span>
          </p>
        </div>
        <div className="header-right">
          <p className="property-price">
            Rp. 780.000 <span className="per-night">/ night</span>
          </p>
        </div>
      </header>

      <div className="photo-gallery">
        <div
          className="main-photo-container"
          onClick={() => openGallery(0)}
          style={{ cursor: "pointer" }}
        >
          <img
            src="https://pix8.agoda.net/hotelImages/394319/-1/8740f4b31b678f40cca7876cd813e2b8.jpg?ca=29&ce=0&s=1024x"
            alt="Main"
            className="main-photo"
          />
          <button className="photo-360-button">
            <FaCamera /> See all photos{" "}
            {extraPhotos > 0 && `+${extraPhotos} Foto`}
          </button>
        </div>
        <div className="thumbnail-row">
          {Array.from({ length: displayedPhotos }, (_, i) => (
            <img
              key={i}
              src="https://pix8.agoda.net/hotelImages/394319/-1/8740f4b31b678f40cca7876cd813e2b8.jpg?ca=29&ce=0&s=1024x"
              alt={`Thumb ${i + 1}`}
              className="thumbnail"
              onClick={() => openGallery(i)}
              style={{ cursor: "pointer" }}
            />
          ))}
        </div>
      </div>
      <LightGallery
        onInit={(lg) => {
          lightGalleryRef.current = lg;
        }}
        dynamic
        dynamicEl={images}
        speed={500}
        plugins={[lgZoom, lgThumbnail]}
      />
      <nav className="detail-nav">
        <ul>
          <li className="active">Overview</li>
          <li>Facilities</li>
          <li>Reviews</li>
          <li>Location</li>
        </ul>
      </nav>
      <section className="detail-content">
        <h2 className="section-title">Overview</h2>
        <p className="section-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
          interdum nunc et augue bibendum, in finibus leo lacinia. Integer nec
          nisl nec risus pretium vulputate et non nisi.
        </p>

        <h2 className="section-title">Facilities</h2>
        <ul className="facilities-list">
          <li>Free Wi-Fi</li>
          <li>Air Conditioning</li>
          <li>24-hour front desk</li>
          <li>Free parking</li>
        </ul>
      </section>
      <div className="sticky-cta-container">
        <button className="sticky-cta-button">Book Now</button>
      </div>
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <div className="map-container">
              <iframe
                title="Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31693.55067990716!2d-122.08424965!3d37.42206505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb732bf42d87b%3A0x26fa131ff6c81775!2sGoogleplex!5e0!3m2!1sen!2sus!4v1616179859861!5m2!1sen!2sus"
                frameBorder="0"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailRoom;
